import { render } from "./FruitCompare.vue?vue&type=template&id=6fe25c03"
import script from "./FruitCompare.vue?vue&type=script&lang=js"
export * from "./FruitCompare.vue?vue&type=script&lang=js"
script.render = render

export default script